import React from 'react';
import { Link } from 'react-router-dom';
import ElementUsage from './ElementUsage';
import ElementEditor from './ElementEditor';

const ElementBuilder = ({ match }) => {
  const elementId = parseInt(match.params.elementId, 10);
  return (
    <>
      <div className="mb-32 mt-24 ff-ss">
        <Link className="u-link mb-24 d-ib" to="/content/library/elements">
          {t('contents.library.element_library.title')}
        </Link>
        <h1 className="Index-title">{t('element_builder.title')}</h1>
      </div>
      <ElementEditor elementId={elementId} />
      <ElementUsage elementId={elementId} />
    </>
  );
};

export default ElementBuilder;
